export default {
    data() {
        return {
            open: false
        }
    },

    methods: {
        toggle() {
            this.open = ! this.open;
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/components/Accordion.js